module.exports = __webpack_public_path__ + "img/asbestos_icon.132b4f7f.svg";